import { render, staticRenderFns } from "./OrganizationApplications.vue?vue&type=template&id=0262d954&"
import script from "./OrganizationApplications.vue?vue&type=script&lang=js&"
export * from "./OrganizationApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VProgressCircular,VTreeview})
